<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="germplasm.import.header"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<div>
		<h3 jhiTranslate="germplasm.import.basicDetails.header"></h3>
		<form name="detailsForm" #detailsForm="ngForm">
		<div jhiTranslate="germplasm.import.basicDetails.description" *ngIf="!hasAllBasicDetails()"></div>
			<div class="mb-3 row required">
				<label for="breedingMethod" class="col-sm-3 col-form-label fw-bold" jhiTranslate="germplasm.import.basicDetails.breeding.methods"></label>
				<div class="col-sm-6" *ngIf="!hasAllBreedingMethods() else allGood">
					<!-- TODO Permissions
					<a style="margin-left: 5px; float: right" jhiTranslate="breeding-method.browser.title"
					   (click)="openBreedingMethodManager()"></a>
					   -->
					<jhi-breeding-methods-select [(value)]="selectedBreedingMethodId"
												 [useFavoriteBreedingMethods]="true"
												 [breedingMethodFilterTypeValue]="BreedingMethodFilterTypeEnum.ALL_METHODS"
												 [selectWidth]="'100%'"
												 [showMethodTypeFilterSection]="false"
												 (onMethodChanged)="onMethodChange($event)"></jhi-breeding-methods-select>
				</div>
			</div>

			<div class="mb-3 row required">
				<label for="breedingAndCountryLocation" class="col-sm-3 col-form-label fw-bold" jhiTranslate="germplasm.import.basicDetails.locations"></label>
				<div class="col-sm-6" *ngIf="!hasAllLocations() else allGood">
                    <jhi-locations-select id="breedingAndCountryLocation"
                                          [(value)]="locationSelectedId"
                                          [showFilterOptions]="true"
                                          [showFavoritesCheckbox]="true"
                                          (valueChange)="onLocationValueChanged($event)">
                    </jhi-locations-select>
				</div>
			</div>
			<div class="mb-3 row required">
				<label for="creationDate" class="col-sm-3 col-form-label fw-bold" jhiTranslate="germplasm.import.basicDetails.creation.date"></label>
				<div class="col-sm-6" *ngIf="!hasAllCreationDate() else allGood">
					<div class="row">
						<div class="input-group col-xs-12 col-md-12">
							<input class="form-control" [placeholder]="'global.date.placeholder' | translate" [(ngModel)]="creationDateSelected"
								   ngbDatepicker #date="ngbDatepicker" id="creationDate" name="creationDate"/>
								<button class="btn btn-outline-secondary calendar" (click)="date.toggle()" type="button"><i class="fa fa-calendar"></i></button>
						</div>
					</div>
				</div>
			</div>
			<div class="mb-3 row">
				<label for="reference" class="col-sm-3 col-form-label fw-bold" jhiTranslate="germplasm.import.basicDetails.reference"></label>
				<div class="col-sm-6" *ngIf="!hasAllReference() else allGood">
					<div class="row">
						<div class="input-group col-xs-12 col-md-12">
							<input class="form-control" [(ngModel)]="referenceSelected" id="reference" name="reference" maxlength="255"/>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
	<br/>
	<div>
		<h3 jhiTranslate="germplasm.import.basicDetails.names.and.attributes.header"></h3>
		<form name="namesAndAttributesForm" #namesAndAttributesForm="ngForm">
			<div class="mb-3 row required" *ngIf="unmapped.length">
				<label for="unmapped" class="col-sm-2 col-form-label fw-bold" jhiTranslate="germplasm.import.basicDetails.unmapped"></label>
				<div class="col-sm-9">
					<p-table styleClass="table table-striped table-bordered table-curved"
							 [autoLayout]="true"
							 [value]="unmapped">
						<ng-template pTemplate="header">
							<tr>
								<th jhiTranslate="germplasm.import.basicDetails.column.code">CODE</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-rowData>
							<tr pDraggable="dd" (onDragStart)="dragStart($event, rowData)" (onDragEnd)="dragEnd($event)"
								style="cursor: move">
								<td>{{rowData}}</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
			<div class="mb-3 row">
				<label for="names" class="col-sm-2 col-form-label fw-bold" jhiTranslate="germplasm.import.basicDetails.names"></label>
				<div class="col-sm-9">
					<p-table styleClass="table table-striped table-bordered table-curved"
							 [autoLayout]="true"
							 [value]="context.nametypesCopy"
							 pDroppable="dd" (onDrop)="drop($event, 'names')">

						<ng-template pTemplate="header">
							<tr>
								<th *ngIf="hasEmptyPreferredName"></th>
								<th *ngIf="hasEmptyPreferredName" jhiTranslate="germplasm.import.basicDetails.column.priority">PRIORITY</th>
								<th jhiTranslate="germplasm.import.basicDetails.column.name.type">NAME TYPE</th>
								<th jhiTranslate="germplasm.import.basicDetails.column.desc">DESCRIPTION</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-rowData let-index="rowIndex">
							<tr [pReorderableRow]="index">
								<td *ngIf="hasEmptyPreferredName">
									<i class="fa fa-bars" style="cursor: move" pReorderableRowHandle></i>
								</td>
								<td *ngIf="hasEmptyPreferredName">{{index+1}}</td>
								<td>{{rowData.code}}</td>
								<td>{{rowData.name}}</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
			<div class="mb-3 row">
				<label for="attributes" class="col-sm-2 col-form-label fw-bold" jhiTranslate="germplasm.import.basicDetails.attributes"></label>
				<div class="col-sm-9">
					<p-table styleClass="table table-striped table-bordered table-curved table-fixed"
							 [autoLayout]="true"
							 [value]="context.attributesCopy"
							 pDroppable="dd" (onDrop)="drop($event, 'attributes')">

						<ng-template pTemplate="header">
							<tr>
								<th jhiTranslate="germplasm.import.basicDetails.column.varname">VARIABLE NAME</th>
								<th jhiTranslate="germplasm.import.basicDetails.column.desc">DESCRIPTION</th>
								<th jhiTranslate="germplasm.import.basicDetails.column.type">TYPE</th>
								<th jhiTranslate="germplasm.import.basicDetails.column.status">STATUS</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-rowData>
							<tr>
								<td>
									<a [routerLink]="['.', { outlets: { popup: 'variable-details-popup' }}]"
									   [queryParams]="{ variableId: rowData.id }">
									{{rowData.alias || rowData.name}}
									</a>
								</td>
								<td>{{rowData.description}}</td>
								<td>{{rowData.variableTypes[0].name}}</td>
								<td [innerHTML]="getStatusIcon(rowData)"></td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
		</form>
	</div>
	<div *ngIf="hasProgenitors()">
		<h3 jhiTranslate="germplasm.import.basicDetails.progenitors.header"></h3>
		<form name="progenitorsForm" #progenitorsForm="ngForm">
			<div class="mb-3 row" >
				<label for="progenitorsDropdown" class="col-sm-2 col-form-label fw-bold" jhiTranslate="germplasm.import.basicDetails.progenitors.label"></label>
				<div class="col-sm-6">
					<select class="form-select" [(ngModel)]="context.pedigreeConnectionType" #progenitorsDropdown="ngModel" name="progenitorsDropdown">
						<option [value]="PedigreeConnectionType.GID">GID</option>
						<option [value]="PedigreeConnectionType.GUID">GUID</option>
					</select>
				</div>
			</div>
		</form>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="back()">
		<span jhiTranslate="back"></span>
	</button>
	<button (click)="next()" [disabled]="!canProceed(detailsForm)" class="btn btn-primary" data-test="importGermplasmDetailsNextButton">
		<span jhiTranslate="next"></span>
	</button>
</div>
<ng-template #allGood>
	<label class="col form-control-plaintext">
        <span [innerHTML]="'germplasm.import.basicDetails.success.message' | translate"></span><span class="fa fa-check text-success"></span>
	</label>
</ng-template>
